import { isValidLegalName, LEGAL_NAME_FORMAT_MESSAGE } from './legalName'
import { ogrnValidationMessage } from './ogrn'

export type VenueFormField = 'ogrn' | 'legalName' | 'tradeName' | 'city'

export type VenueFormFieldErrors = Partial<Record<VenueFormField, string>>

export type VenueFormValues = {
  ogrn: string
  legalName: string
  tradeName: string
  city: string
  /** Не показываем в UI; передаём с бэка / дефолтом при создании. */
  horecaType: string
}

export const hasVenueFormErrors = (errors: VenueFormFieldErrors): boolean =>
  Object.keys(errors).length > 0

export const validateVenueForm = (values: VenueFormValues): VenueFormFieldErrors => {
  const errors: VenueFormFieldErrors = {}

  const ogrnError = ogrnValidationMessage(values.ogrn)
  if (ogrnError) {
    errors.ogrn = ogrnError
  }
  if (!values.legalName.trim()) {
    errors.legalName = 'Введите юридическое название'
  } else if (!isValidLegalName(values.legalName)) {
    errors.legalName = LEGAL_NAME_FORMAT_MESSAGE
  }
  if (!values.tradeName.trim()) {
    errors.tradeName = 'Введите торговое название'
  }
  if (!values.city.trim()) {
    errors.city = 'Выберите город'
  }

  return errors
}
